/* STYLIVE Wholesale v2.0. UI only. Authorization is decided in Liquid.
 * No passwords, documents, application data, or approval state are stored here.
 */
(function () {
  'use strict';
  if (window.__styliveWholesaleInitialized) return;
  window.__styliveWholesaleInitialized = true;
  var RETURN_KEY = 'stylive-wholesale-return-path';

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  function safeReturn(raw) {
    if (typeof raw !== 'string' || !raw || /[\\\u0000-\u001f]/.test(raw)) return null;
    try {
      var url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      var decodedPath = decodeURIComponent(url.pathname);
      if (!/^\//.test(decodedPath) || /^\/\//.test(decodedPath) || /[\\\u0000-\u001f\u007f]/.test(decodedPath)) return null;
      if (/%(2f|5c|25)/i.test(url.pathname)) return null;
      if (/(^|\/)(account|challenge|checkout|checkouts|policies)(\/|$)/i.test(decodedPath)) return null;
      if (/\.(js|json|xml|atom)$/i.test(decodedPath)) return null;
      if (url.searchParams.has('section_id') || url.searchParams.has('sections') || url.searchParams.has('view')) return null;
      url.searchParams.delete('return_to');
      url.searchParams.delete('return_url');
      return url.pathname + url.search;
    } catch (_) { return null; }
  }
  function readStoredPath() {
    try { return safeReturn(sessionStorage.getItem(RETURN_KEY)); } catch (_) { return null; }
  }
  function writeStoredPath(path) {
    try { sessionStorage.setItem(RETURN_KEY, path); } catch (_) { /* Optional preference only. */ }
  }

  function initializeFormHosts(scope) {
    scope.querySelectorAll('[data-stylive-cf-host]').forEach(function (host) {
      if (host.dataset.swObserved === 'true') return;
      host.dataset.swObserved = 'true';
      var loading = host.querySelector('[data-stylive-cf-loading]');
      var failure = host.querySelector('[data-stylive-cf-error]');
      function loaded() { return !!host.querySelector('input:not([type="hidden"]),select,textarea,iframe,[data-cf-field]'); }
      var timer;
      var observer;
      function check() {
        if (!loaded()) return false;
        if (loading) loading.hidden = true;
        if (failure) failure.hidden = true;
        clearTimeout(timer);
        if (observer) observer.disconnect();
        return true;
      }
      if (check()) return;
      observer = new MutationObserver(check);
      observer.observe(host, { childList: true, subtree: true });
      timer = window.setTimeout(function () {
        if (check()) return;
        if (loading) loading.hidden = true;
        if (failure) failure.hidden = false;
        // Keep observing: a slow app may become available later.
      }, 15000);
    });
  }

  ready(function () {
    initializeFormHosts(document);
    document.addEventListener('shopify:section:load', function (event) {
      initializeFormHosts(event.target);
    });
    var gate = document.querySelector('[data-stylive-wholesale-gate]');
    if (!gate) return;
    var dialog = gate.querySelector('[data-sw-dialog]');
    var panels = gate.querySelectorAll('[data-sw-panel]');
    var isCustomer = gate.dataset.swCustomer === 'true';
    var root = safeReturn(gate.dataset.swRoot) || '/';
    var requested = new URLSearchParams(window.location.search);
    var returnPath = safeReturn(requested.get('return_url')) || safeReturn(requested.get('return_to'));
    var current = safeReturn(window.location.pathname + window.location.search);
    returnPath = returnPath || (current && current !== root ? current : null) || readStoredPath() || root;
    writeStoredPath(returnPath);
    gate.querySelectorAll('[data-sw-return-to]').forEach(function (input) { input.value = returnPath; });
    gate.querySelectorAll('[data-sw-hosted-login]').forEach(function (link) {
      try {
        var loginURL = new URL(link.href, window.location.origin);
        if (loginURL.origin === window.location.origin && /\/customer_authentication\/login$/.test(loginURL.pathname)) {
          loginURL.searchParams.set('return_to', returnPath);
          link.href = loginURL.pathname + loginURL.search;
        }
      } catch (_) {}
    });

    function panelFromHash() {
      var map = { '#wholesale-login': 'login', '#wholesale-register': 'register', '#wholesale-recover': 'recover', '#recover': 'recover' };
      return map[window.location.hash] || dialog.dataset.swDefaultPanel || 'login';
    }
    function showPanel(name, focus) {
      if (!panels.length) return;
      // A hash can select a view, never grant access or change approval status.
      if (isCustomer) name = 'pending';
      if (!['login', 'register', 'recover', 'pending'].includes(name)) name = 'login';
      panels.forEach(function (panel) { panel.hidden = panel.dataset.swPanel !== name; });
      dialog.dataset.activePanel = name;
      if (focus) {
        var heading = gate.querySelector('[data-sw-panel="' + name + '"] .sw-heading');
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    }
    if (panels.length) {
      var initial = gate.querySelector('[data-sw-recover-result]') ? 'recover' : panelFromHash();
      if (gate.querySelector('[data-sw-login-error]')) initial = 'login';
      showPanel(initial, false);
      window.addEventListener('hashchange', function () { showPanel(panelFromHash(), true); });
      gate.addEventListener('click', function (event) {
        var link = event.target.closest('[data-sw-panel-link]');
        if (!link) return;
        event.preventDefault();
        var name = link.dataset.swPanelLink;
        history.replaceState(null, '', '#wholesale-' + name);
        showPanel(name, true);
      });
    }
    gate.querySelectorAll('[data-sw-password-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = document.getElementById(button.getAttribute('aria-controls'));
        if (!input) return;
        var visible = input.type === 'password';
        input.type = visible ? 'text' : 'password';
        button.textContent = visible ? 'HIDE' : 'SHOW';
        button.setAttribute('aria-pressed', String(visible));
        button.setAttribute('aria-label', visible ? 'Hide password' : 'Show password');
      });
    });
    // There is deliberately no close action or backdrop/escape dismissal.
    // Because this is the only page content, there is no hidden catalogue to reveal.
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      // Leave embedded app/captcha keyboard interactions alone.
      if (event.target.closest('[data-stylive-cf-host]')) return;
      var targets = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(function (el) { return el.getClientRects().length > 0; });
      if (!targets.length) return;
      var first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    var feedback = gate.querySelector('[data-sw-login-error], [data-sw-recover-result]');
    if (feedback && !feedback.closest('[hidden]')) feedback.focus({ preventScroll: true });
  });
  // Re-check server-side access after restoring a page from browser back/forward cache.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) window.location.reload();
  });
})();
